var React = require('react');

function HeartFilled (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"nc-icon-wrapper","fill":"#111111"},React.createElement("path",{"fill":"#f45342","d":"M21.95,3.051C20.627,1.729,18.87,1,17,1s-3.627,0.729-4.949,2.05C12.034,3.067,12.017,3.084,12,3.102 c-0.017-0.018-0.033-0.034-0.05-0.051C10.627,1.729,8.87,1,7,1S3.373,1.729,2.05,3.051S0,6.13,0,8s0.728,3.627,2.05,4.949l9.95,9.95 l9.95-9.95C23.272,11.627,24,9.87,24,8C24,6.131,23.272,4.373,21.95,3.051z"})));
}

HeartFilled.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 24 24","xmlSpace":"preserve","width":"24","height":"24"};

module.exports = HeartFilled;

HeartFilled.default = HeartFilled;
